<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="loading"></loading-placeholder>

        <el-table :data="data" stripe border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="competition_name" label="赛事名称" align="center" min-width="180"></el-table-column>
            <el-table-column prop="school_name" label="学校名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="team_name" label="队伍名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="status_text" label="申请状态" align="center" min-width="80"></el-table-column>
            <el-table-column prop="create_time_text" label="申请时间" align="center" width="140"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            data: {
                type: Array,
                default: () => []
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        },
        methods: {
            apply () {
            }
        }
    };
</script>
